import React, { useEffect, useState, useRef } from "react";
import img2 from "../img1.png"

// 🔥 Reusable counter hook
function useCounter(target, duration, trigger) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!trigger) return;
    let startValue = 0;
    const totalFrames = Math.round((duration / 1000) * 60);
    let frame = 0;

    const counter = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      setCount(Math.floor(progress * (target - startValue) + startValue));
      if (frame === totalFrames) clearInterval(counter);
    }, 1000 / 60);

    return () => clearInterval(counter);
  }, [target, duration, trigger]);

  return count;
}

const AnimatedNumber = ({ value, suffix, trigger }) => {
  const count = useCounter(value, 2000, trigger); // 2s animation
  return (
    <span>
      {count}
      {suffix}
    </span>
  );
};

const StatsSection = () => {
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);

  // 👀 Observe visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const stats = [
    {
      label: "Clients",
      value: 25,
      suffix: "+",
      description:
        "Trusted by leading automotive, agriculture, aerospace, and lift system brands across the globe.",
    },
    {
      label: "Experience",
      value: 45,
      suffix: "+",
      description:
        "Delivering precision-engineered fasteners and components since 1981.",
    },
    {
      label: "Certifications",
      value: 30,
      suffix: "+",
      description:
        "Globally recognized standards including IATF 16949:2016 & MACE Green Vendor Certification.",
    },
  ];

  return (
    <section
      ref={sectionRef}
      className="w-full bg-blue-200 py-16 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-12">
        {/* Top - Image */}
        <div className="w-full">
          <img
            src={img2}
            alt="Team working"
            className="w-full rounded-2xl object-cover"
          />
        </div>

        {/* Bottom - Stats */}
        <div className="w-full space-y-12">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {stat.label}
                </h3>
                <p className="text-6xl font-bold text-black">
                  <AnimatedNumber
                    value={stat.value}
                    suffix={stat.suffix}
                    trigger={isInView} // ✅ triggers count every time visible
                  />
                </p>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                  {stat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
